export class DialogModelOutstandingPopUp {
  constructor(public osData: any) {}
}
